<div
  class="rt-card"
  [class.rt-card-clickable]="canViewCandidateProfile && !candidateDeleted"
  padding-medium
>
  <div class="container">
    <div layout layout-align-items-center>
      <div margin-right>
        <rt-avatar
          [type]="filledOpening.placement?.candidate?.photoThumbUrl ? 'image' : 'icon'"
          [initials]="filledOpening.placement?.candidate?.initials"
          [imageSrc]="filledOpening.placement?.candidate?.photoThumbUrl ?? null"
          [size]="'base'"
          [iconName]="'person'"
        >
        </rt-avatar>
      </div>
      <div layout-vertical>
        <rt-heading class="candidate-name">
          @if (!candidateDeleted && filledOpening.placement?.candidate; as placementCandidate) {
            <span>{{ placementCandidate.name }} </span>
          } @else {
            <div
              [rtTooltip]="
                'app.requisitions.openings.candidate_removed_from_system_tooltip' | translate
              "
              [rtTooltipHasTextAlignCenter]="true"
            >
              {{ 'app.requisitions.openings.unknown_candidate' | translate }}
            </div>
          }
        </rt-heading>

        <div class="details" layout layout-align-items-center>
          @if (filledOpening.placement?.disqualifyReason) {
            <div class="disqualify-reason-container">
              <rt-icon size="small-x" name="block"> </rt-icon>
              <div
                [rtTooltip]="'app.requisitions.openings.candidate_disqualified_tooltip' | translate"
                [rtTooltipHasTextAlignCenter]="true"
              >
                <rt-truncate>
                  {{ filledOpening.placement?.disqualifyReason }}
                </rt-truncate>
              </div>
            </div>
          }
          @if (!candidateDeleted && filledOpening.placement?.offer; as placementOffer) {
            <rt-offer-status-indicator
              [offerStatus]="placementOffer"
              margin-right-small-x
              margin-left-small-xx
            ></rt-offer-status-indicator>
            <span text-weight-semi-bold>
              {{ placementOffer.title! }}
            </span>
          } @else {
            {{ 'app.requisitions.openings.unknown_job' | translate }}
          }

          @if (filledOpening.anticipatedStartDate || filledOpening.reason) {
            <div layout layout-align-items-center>
              <rt-divider [variant]="'dot'"></rt-divider>
              @if (filledOpening.reason) {
                <div margin-right-small-x>
                  {{ displayOpeningReason(filledOpening.reason) }}
                </div>
              }
              @if (filledOpening.anticipatedStartDate) {
                <div
                  layout
                  layout-align-items-center
                  [rtTooltip]="'app.requisitions.start_date' | translate"
                >
                  <rt-icon
                    [name]="'calendar-today'"
                    colorToken="colorIconDefault"
                    margin-right-small-xx
                  ></rt-icon>
                  {{ displayAnticipatedStartDate(filledOpening.anticipatedStartDate) }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>

    @if (canUnassignCandidates && candidateDeleted) {
      <div
        class="unassign-button"
        [rtTooltip]="
          !!filledOpening.placement
            ? ('app.requisitions.openings.candidate_recently_deleted_tooltip' | translate)
            : ('app.requisitions.openings.candidate_deleted_tooltip' | translate)
        "
        [rtTooltipHasTextAlignCenter]="true"
      >
        <rt-button
          variant="plain"
          [disabled]="!!filledOpening.placement"
          (click)="unassignCandidate.emit(filledOpening.id)"
        >
          <rt-icon name="block"></rt-icon>
          {{ 'app.requisitions.openings.unassign_candidate' | translate }}
        </rt-button>
      </div>
    }
  </div>
  @if (canViewCandidateProfile && !candidateDeleted) {
    <a
      [routerLink]="['.']"
      [queryParams]="{
        candidate: filledOpening.placement?.candidate?.id
      }"
      queryParamsHandling="merge"
      class="candidate-profile-link"
    >
    </a>
  }
</div>
